import {call, put, takeLatest} from 'redux-saga/effects';
import {
    MERCHANT_PRODUCT_DATA_QUERY_START,
    MerchantProductDataQueryStartAction,
    getMerchantProductDataQuerySuccessAction,
    getMerchantProductDataQueryFailedAction
} from "../actions/MerchantProductSearchAction";
import ApiUtil from "src/utils/ApiUtil";
import {
    GENERAL_PRODUCT_DATA_QUERY_START,
    GeneralProductDataQueryStartAction,
    getGeneralProductDataQueryFailedAction,
    getGeneralProductDataQuerySuccessAction
} from "src/actions/GeneralProductSearchAction";


export function* getProductData(action: MerchantProductDataQueryStartAction | GeneralProductDataQueryStartAction) {
    try {
        let parameters: any = {searchKey: action.searchKey, countryCode: action.countryCode, searchType: action.searchType, pageOffset: action.pageOffset};
        // @ts-ignore
        const response = yield call(ApiUtil.callApiWithTimeout, "productmatchpage", parameters);
        if (MERCHANT_PRODUCT_DATA_QUERY_START === action.type) {
            yield put(getMerchantProductDataQuerySuccessAction(response));
        } else {
            yield put(getGeneralProductDataQuerySuccessAction(response));
        }
    } catch (error) {
        console.error("Call API productmatchpage error" + error)
        if (MERCHANT_PRODUCT_DATA_QUERY_START === action.type) {
            yield put(getMerchantProductDataQueryFailedAction());
        } else {
            yield put(getGeneralProductDataQueryFailedAction());
        }
        return;
    }
}

export default function* productData() {
    yield takeLatest([MERCHANT_PRODUCT_DATA_QUERY_START, GENERAL_PRODUCT_DATA_QUERY_START], getProductData);
}